import { get, post } from "api/apiBridges/httpBridge";
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { Box, Collapse, IconButton, List, ListItemButton, ListItemText, Modal, Switch, TextField, Tooltip, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import usePreventDoubleClick from "components/AntiDBC";
import { TextInput } from "./LittleComponents";
import Scrollbars from "rc-scrollbars";
import Loading from 'components/Load';
import { ShowModal } from "components/Modal";
import DeleteIcon from '@mui/icons-material/Delete';
import { hoverStyle } from "styles/main";

export default function Roles({ds, data, setChanged}){
  console.log("Roles", ds)
  const [$data, $setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const { company_id, rules } = useSelector(
    loginSelector
  );

  const [canChange, setCanChange] = useState(rules.includes("admin") || rules.includes("company.change_roles"));
  const preventDoubleClick = usePreventDoubleClick();

  

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const responseData = await get('Roles/getCompanyRoles', {cid:company_id});
        let res = []
        if (responseData){
          responseData.map((el) => {
            let rules = []
            el.rules.map((rule) => {rules.push({id:rule, active:true})})
            res.push({id:el.id, company_id:el.company_id, title:el.title, rules})
          })
        }
        console.log(res)
        $setdata(res);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []); 

  //todo добавить права
  const addNewRole = async () => {
    let name =`Новая роль ${$data.length + 1}`
    let role = await post('Roles/create', 
      {
        company_id, 
        title: name, 
        rules:[]
      }
    )
    $setdata([...$data, {id:role.message.id, title:name, rules:[]}])
    if (setChanged) setChanged(true);
  }

  const delRole = async (rid) => {
    try {
      setLoading(true)
      let tmp = JSON.parse(JSON.stringify($data))
      await post("Roles/del", {id: rid})
      await data.delRole(rid)
      tmp = tmp.filter((el) => el.id !== rid)
      $setdata(tmp)
      if (setChanged) setChanged(true);
    }
    catch (err) {}
    finally {setLoading(false)}
    
  }

  if (loading) {
    return (<Loading></Loading>);
  }

  return (
    <>
      <div style={{display: 'flex', flexDirection: "column", alignItems: 'center', height: "90%", justifyContent: "flex-start"}}>
        <Scrollbars
          autoHide
        >
          {$data.map((item) => {
            return(
              <Role data={item} ds={ds} canChange={canChange} onDel={delRole} setChangedProp={setChanged}/>
            )
          })}
        </Scrollbars>
        {canChange && <Button onClick={preventDoubleClick(addNewRole, 1000)}>Добавить роль </Button>}
      </div>
    </>
  );
}

function Role({data, ds, canChange, onDel, setChangedProp}){

  console.log(data, ds)

  const [$data, $setdata] = useState(data);
  let [open, setOpen] = useState(false);
  let [changed, setChanged] = useState(false);

  const ListHandleClick = () => {
    setOpen(JSON.parse(JSON.stringify(!open)));
  };


  const HandleClick = async (id) => {
    let tmp = JSON.parse(JSON.stringify($data))
    const idx = tmp.rules.findIndex((el) => el.id === id);
    console.log(idx)
    if (idx >= 0) {
      tmp.rules[idx] = {id:id, active:!tmp.rules[idx].active}
    }
    else {tmp.rules.push({id:id, active:true})}
    console.log(tmp.rules)
    let arules = []
    tmp.rules.map((rule) => {
      if (rule.active) arules.push(rule.id)
    })
    $setdata(tmp);
    setChanged(true)
    if (setChangedProp) setChangedProp(true)
  }

  const setName = (val) => {
    let tmp = JSON.parse(JSON.stringify($data))
    tmp.title = val
    $setdata(tmp)
    setChanged(true)
    if (setChangedProp) setChangedProp(true)
  }

  const save = async () => {
    console.log("save", $data)
    let obj = {
      id: $data.id,
      title: $data.title,
      rules: $data.rules.filter(item => item.active).map(item => item.id)
    }
    setChanged(false)
    await post('Roles/update', obj)
  }

  const handleClickDelRole = () => {
    ShowModal('Удалить роль', 
    <div>Вы уверены, что хотите удалить роль? Она будет удалена у всех сотрудников</div>, 
    async () => {
        try {
          onDel(data.id)
        }
        catch (err) {}
        finally {}
        
    });
  }

  return (
    <>
      <div style={{width: "100%"}}>
        <ListItemButton onClick={() => ListHandleClick()}>
          <ListItemText primary={$data.title} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>  
        <Collapse in={open} timeout="auto" unmountOnExit>
          <div style={{margin: "5px", display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-between'}}>
            <TextInput 
              title="Название роли" 
              val={$data.title} 
              onChange={(e) => setName(e)} 
            />
            {canChange && 
              <Tooltip title="Удалить роль">
                <IconButton onClick={handleClickDelRole}>
                  <DeleteIcon
                    sx={{
                      transition: 'all 0.3s ease',
                      '&:hover': hoverStyle
                    }}
                  />
                </IconButton>
              </Tooltip>
            }
          </div>
          <List component="div" disablePadding  style={{display:"flex", flexDirection:'column'}}>
              {
                ds.descr.rules.map((rule) => (
                  <div style={{display:"flex", flexDirection:'row', alignItems:"center", borderRadius:'10px', backgroundColor:"#cfcfd4", margin:"5px"}}> 
                    <Switch
                    color="primary"
                    checked={$data.rules.find((el) => el.id == rule.id)?.active || false}
                    onClick={() => HandleClick(rule.id)}
                    disabled={!canChange}
                  />
                  {rule.title}
                  </div>
                ))
              }
          </List>
        </Collapse>
        {canChange && changed && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '5px' }}>
            <Button 
              onClick={save} 
              variant="contained" 
              sx={{ 
                textTransform: 'none', 
                backgroundColor: colors.elements, 
                fontWeight: 'bold' 
              }}
            >
              Сохранить
            </Button>
          </div>
        )}
      </div>
    </>
  )
}